import React, { useState } from "react";
import { supabase } from "../../supabaseClient";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Authorize() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const stateId = searchParams.get("state_id");
  const redirectUri = searchParams.get("redirect_uri");

  console.log(stateId, redirectUri);

  if (!stateId || !redirectUri || stateId === null || redirectUri === null) {
    navigate("/");
  }

  return (
    <div className="w-full flex justify-center p-16 items-center ">
      <div className="gap-4 flex flex-col  w-1/2 p-4 justify-center items-center">
        <h1 className="text-xl font-bold">Welcome to Code on the Rocks</h1>
        <p className="text-lg">Log in to your account to continue</p>
        <input
          placeholder="Email"
          className="input input-bordered w-full"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        ></input>
        <input
          placeholder="Password"
          className="input input-bordered w-full"
          type="text"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        ></input>
        <button
          className="btn btn-primary w-full"
          onClick={async () => {
            const token = await supabase.auth.signInWithPassword({
              email: email,
              password: password,
            });

            if (token) {
              // redirect
              window.open(
                `${redirectUri}${
                  token.data.session?.access_token
                    ? `?access_token=${token.data.session?.access_token}&state=${stateId}&refresh_token=${token.data.session?.refresh_token}`
                    : ""
                }`,
                "_blank"
              );
            }
          }}
        >
          Log In
        </button>
        <label className="italic">
          You will be redirected to VS Code once you log in
        </label>
      </div>
    </div>
  );
}
